import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import axios from "axios";
import { baseurl } from "../../config/url";

const OrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { order } = location.state || {};

  const [trackingId, setTrackingId] = useState(order?.trackingId || "");
  const [status, setStatus] = useState(order?.status || "Pending");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);

    if (newStatus === "Delivered") {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.put(
          `${baseurl}/api/order-tracking/update-ordertracking/${order._id}`,
          { status: newStatus },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.message.includes("OTP sent")) {
          setIsOtpSent(true);
          showSuccessToast("OTP sent to the customer's email.");
        }
      } catch (error) {
        showErrorToast(error.response?.data?.message || "Error sending OTP.");
        setStatus(order.status);
      }
    } else {
      setIsOtpSent(false);
      setIsOtpVerified(false);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${baseurl}/api/order-tracking/verify-otp/${order._id}`,
        { otp },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      showSuccessToast(response.data.message);
      setIsOtpVerified(true);
    } catch (error) {
      showErrorToast(error.response?.data?.message || "Error verifying OTP.");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Order Details</h1>
      <div className="bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto">
        <p>
          <strong>Order ID:</strong> {order._id}
        </p>
        <p>
          <strong>Customer:</strong> {order.user.name}
        </p>
        <p>
          <strong>Current Status:</strong> {order.status}
        </p>

        <select
          value={status}
          onChange={handleStatusChange}
          className="border rounded px-3 py-1 mt-2"
        >
          <option value="Pending">Pending</option>
          <option value="Shipped">Shipped</option>
          <option value="Delivered">Delivered</option>
        </select>

        {isOtpSent && (
          <div className="mt-4">
            <label className="block text-sm font-medium">Enter OTP:</label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="OTP"
              className="border rounded px-3 py-1 mt-2"
            />
            <button
              onClick={handleVerifyOtp}
              className="bg-blue-500 text-white px-4 py-2 rounded mt-4 hover:bg-blue-600"
              disabled={isOtpVerified}
            >
              {isOtpVerified ? "OTP Verified" : "Verify OTP"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;
